import { render, staticRenderFns } from "./TaskMoneyConfigtbfjsp.vue?vue&type=template&id=5f374bb0&"
import script from "./TaskMoneyConfigtbfjsp.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigtbfjsp.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigtbfjsp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports